import { configureStore } from '@reduxjs/toolkit';
import userReducer from '../src/redux/slices/userSlice';
import authReducer from '../src/redux/slices/authSlice';

const store = configureStore({
  reducer: {
    user: userReducer,  // Handles user-related state
    auth: authReducer,  // Handles authentication-related state
  },
});

export default store;